import {loadOneType} from "./load_one_type.js";
import {Query} from "./query.js";

export function loadAllTypes(action, dispatch, sessions) {
  return Promise.all(
    Object.keys(Query).map((t) => loadOneType(t, action, dispatch, sessions))
  );
}
